import { render, staticRenderFns } from "./requested-status-form.component.vue?vue&type=template&id=6d4e08fe&"
import script from "./requested-status-form.component.vue?vue&type=script&lang=ts&"
export * from "./requested-status-form.component.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports